import {useEffect, useState} from 'react';
import {Backdrop, Button, CircularProgress, Snackbar} from '@material-ui/core';
import {Alert, AlertTitle} from '@material-ui/lab';
import {useGetUserPrices} from 'hooks/useGetEndpointActive';
import {useContext} from 'react';
import {UserContext} from 'context/UserContext';
import useWindowSize from 'hooks/useWindowSize';

const defaultTitle = 'Applying referral code';

const ReferralModal = ({isLoading, data, error, user}) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [title, setTitle] = useState(defaultTitle);
    const [message, setMessage] = useState();
    const [severity, setSeverity] = useState('info');

    const {width: windowWidth} = useWindowSize();

    useEffect(() => {
        if (isLoading) {
            setModalOpen(true);
            setTitle(defaultTitle);
            setSeverity('info');
        } else if (data || error) {
            setModalOpen(true);
            if (data?.referral_code?.status === 'ok') {
                setTitle('Success!');
                setSeverity('success');
                if (data?.referral_code.message?.match(/self refer/)) {
                    setMessage(
                        'Hey that was sneaky, but enjoy your self reference ;). We like beer and ice cream *hint hint*'
                    );
                } else {
                    setMessage(
                        'Your referral code was applied. Enjoy your free month!'
                    );
                }
            } else {
                if (data?.referral_code?.message?.match(/after free trial/)) {
                    if (user?.permissions?.canAccessWithoutPaymentInfo) {
                        setTitle('');
                        setSeverity('success');
                        setMessage(
                            "Looks like you're on a VIP account, so you don't need to use referral codes to have a good time. You can still share yours with friends though!"
                        );
                    } else {
                        setTitle('There was a problem with your referral code');
                        setSeverity('warning');
                        setMessage(
                            'Referral codes cannot be applied after your trial period'
                        );
                    }
                } else if (
                    data?.referral_code?.message?.match(/Already used/)
                ) {
                    setTitle('There was a problem with your referral code');
                    setSeverity('warning');
                    setMessage(
                        'A referral code has already been applied to your account'
                    );
                } else if (data?.promo?.message?.match(/not found/)) {
                    setTitle('There was a problem with your referral code');
                    setSeverity('warning');
                    setMessage(
                        `${data?.promo?.promo_code} is not a valid referral code`
                    );
                } else {
                    setTitle('There was a problem with your referral code');
                    setSeverity('warning');
                    setMessage(
                        'We had trouble applying your referral code, please contact us so we can help you out.'
                    );
                }
            }
        }
        // eslint-disable-next-line
    }, [isLoading, data, error]);

    return (
        <Backdrop open={modalOpen} style={{zIndex: '1200'}}>
            <Snackbar
                open={modalOpen}
                anchorOrigin={{horizontal: 'center', vertical: 'top'}}
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translateY(-50%) translateX(-50%)',
                    width:
                        windowWidth > 600
                            ? '50%'
                            : windowWidth > 400
                            ? '80%'
                            : '95%',
                }}
                //onClose={() => setModalOpen(false)}
            >
                <Alert
                    variant='filled'
                    severity={severity}
                    elevation={10}
                    action={
                        !data && !error ? (
                            <CircularProgress color='secondary' />
                        ) : (
                            <Button
                                variant='contained'
                                color='default'
                                size='small'
                                onClick={() => setModalOpen(false)}
                            >
                                Close
                            </Button>
                        )
                    }
                >
                    <AlertTitle>{title}</AlertTitle>
                    {data ? message : ''}
                </Alert>
            </Snackbar>
        </Backdrop>
    );
};

const canSubmitReferral = state => state && state !== 'emailNotVerified' && state !== 'loggedOut';

const ReferralModalNetworkWrapper = () => {
    const {updateSubscription} = useContext(UserContext);
    const {user, userState} = useContext(UserContext);
    const {get, data, error, isLoading} = useGetUserPrices();

    useEffect(() => {
        if (get && canSubmitReferral(userState)) {
            const rCode = window.sessionStorage.getItem('REFERRAL_CODE');
            if (rCode) {
                get({promo_code: rCode});
            }
        }
        //eslint-disable-next-line
    }, [get, user]);

    useEffect(() => {
        if (data?.referral_code?.status === 'ok') {
            window.sessionStorage.removeItem('REFERRAL_CODE');
            updateSubscription({
                next_payment_date: data?.applied_referral?.next_payment_date,
            });
        }
        //eslint-disable-next-line
    }, [data]);

    return (
        <ReferralModal
            isLoading={isLoading}
            data={data}
            error={error}
            user={user}
        />
    );
};

export default ReferralModalNetworkWrapper;
export {ReferralModal};
